/** Generic fallback when a list action (enable, disable, delete, restore) fails. */
export const DEFAULT_ACTION_FAILED_MESSAGE =
    "That action couldn't be completed. Please try again.";

/** Generic fallback for unexpected errors in forms, calendar, and admin flows. */
export const DEFAULT_UNEXPECTED_ERROR_MESSAGE = "Something went wrong. Please try again.";

/** Generic form save failure (inline field hints). */
export const DEFAULT_FORM_SAVE_ERROR_TOAST_MESSAGE =
    "Couldn't save. Check highlighted fields and try again.";
